module.exports = __webpack_public_path__ + "img/2_h_no.b8900305.svg";